/**
 * Session-label formatter for the dashboard session picker dropdown.
 *
 * Format: "Apr 28 — bullpen (15)"  when title is present
 *         "Apr 28 — 15 pitches"     when title is absent
 *
 * Date is rendered in America/Chicago per the portal's timezone convention.
 *
 * Same-day duplicates are disambiguated with " #N" appended (caller passes
 * `dupIndex`). When dupIndex is null the disambiguator is omitted.
 *
 * The unit can be overridden for Pocket Radar (`'throw' / 'throws'`).
 */

const DATE_FMT = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/Chicago',
  month: 'short',
  day: 'numeric',
});

export function formatSessionLabel({
  startedAt,
  title = null,
  count = 0,
  dupIndex = null,
  unitSingular = 'pitch',
  unitPlural = 'pitches',
} = {}) {
  const datePart = formatDate(startedAt);
  const titlePart = (title ?? '').trim();
  const countPart = `${count} ${count === 1 ? unitSingular : unitPlural}`;
  const body = titlePart
    ? `${datePart} — ${titlePart} (${count})`
    : `${datePart} — ${countPart}`;
  return dupIndex != null ? `${body} #${dupIndex}` : body;
}

function formatDate(iso) {
  if (!iso) return '—';
  const t = new Date(iso);
  if (Number.isNaN(t.getTime())) return '—';
  return DATE_FMT.format(t);
}
